export const getSearchParamIdToken = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('idToken') ?? undefined;
};
